import { useAuth0 } from '@auth0/auth0-react'
import { UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../types'
import { getCertification, postStartCertificationScreening, postSubmitCertificationScreening } from './certification'
import { CertificationScreening } from './types'

export const useStartCertificationScreeningMutation = (
  options?: UseMutationOptions<CertificationScreening, Error, void>
) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationKey: [QueryKeys.Certification, 'private', 'start'],
    mutationFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await postStartCertificationScreening({ accessToken })
    },
    ...options,
  })
}

export const useSubmitCertificationScreeningMutation = (
  options?: UseMutationOptions<CertificationScreening, Error, { screeningId: string; documents: File[] }>
) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationKey: [QueryKeys.Certification, 'private', 'submit'],
    mutationFn: async ({ screeningId, documents }: { screeningId: string; documents: File[] }) => {
      const accessToken = await getAccessTokenSilently()
      return await postSubmitCertificationScreening({ accessToken, screeningId, documents })
    },
    ...options,
  })
}

export const useGetCertificationQuery = () => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.Certification, 'private', 'get'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getCertification({ accessToken })
    },
  })
}
